/**
 * Normalizes the offset value.
 * @param {number|array} value The value to normalize.
 * @returns {number}
 */
export default (function (value) {
  return typeof value === 'number' || typeof value === 'string' ? [value, value] : value;
});


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/lib/normalizeOffset.js
// module id = 985
// module chunks = 0